module.exports = __webpack_public_path__ + "img/contentImgHover3.8c23023.png";